/**
 * @fileoverview Single source of truth for draft status chips (MOR-529).
 *
 * Title Case labels + soft badge classes, shared by the drafts list rows,
 * the draft reader, and the mail-agent chat draft cards so every surface
 * renders statuses identically.
 */

export const DRAFT_STATUS_META: Record<
  string,
  {
    label: string;
    className: string;
    dotClassName: string;
    textClassName: string;
  }
> = {
  pending: {
    label: "Pending Review",
    className:
      "border-amber-600/20 bg-amber-500/10 text-amber-700 dark:text-amber-400",
    dotClassName: "bg-amber-500",
    textClassName: "text-amber-700 dark:text-amber-400",
  },
  approved: {
    label: "Approving",
    className: "border-border bg-muted text-muted-foreground",
    dotClassName: "bg-muted-foreground/50",
    textClassName: "text-muted-foreground",
  },
  sent: {
    label: "Sent",
    className:
      "border-emerald-700/20 bg-emerald-700/5 text-emerald-800 dark:border-emerald-400/20 dark:bg-emerald-400/10 dark:text-emerald-400",
    dotClassName: "bg-emerald-500",
    textClassName: "text-emerald-700 dark:text-emerald-400",
  },
  failed: {
    label: "Failed",
    className: "border-destructive/30 bg-destructive/5 text-destructive",
    dotClassName: "bg-destructive",
    textClassName: "text-destructive",
  },
  rejected: {
    label: "Rejected",
    className: "border-border bg-muted text-muted-foreground",
    dotClassName: "bg-muted-foreground/50",
    textClassName: "text-muted-foreground",
  },
  superseded: {
    label: "Superseded",
    className: "border-border bg-muted text-muted-foreground",
    dotClassName: "bg-muted-foreground/50",
    textClassName: "text-muted-foreground",
  },
};

export function draftStatusMeta(status: string): {
  label: string;
  className: string;
  dotClassName: string;
  textClassName: string;
} {
  return DRAFT_STATUS_META[status] ?? DRAFT_STATUS_META.pending;
}
